<template>
  <MallPopup
    :value="value"
    @onOpen="onOpen"
    @onClose="onClose"
    :onePurache=" onePurchase ? true : false "
    :title="title" >
    <div v-for="goods of goodsList" :key="goods.goodsId">
      <MallGoods v-if="!onePurchase" :goods="goods"/>
      <MallSpecilPanel :goods="goods" @onChange="onChange" @load="specilLoad"/>
    </div>
    <div v-if="!allNoStock" class="mall-specil-confirm" slot="bottom">
      <slot name="bottom" :confirm="handleConfirm" :disabled="isBtnDisabled">

        <template v-if="needCountDiscount">
          <div class="left__price">￥{{showActualPrice}}</div>
          <div
            class="right__btn layout-flex--c layout-flex_dir--c"
            :style="isBtnDisabled ? 'opacity: 0.4': ''"
            @click="handleConfirm">
            <div class="right__btn-label" v-if="discountPrice">{{discountLabel}}￥{{discountAfterPrice}}</div>
            <div class="right__btn-text" :class="{'right__btn-text--big': !discountLabel}">立即购买</div>
          </div>
        </template>

        <!-- <div class="mall-specil-price" v-if="isShowPrice">
          <div class="mall-specil-price-total">
            <span class="mall-specil-price-total__label">组合价</span>
            <span class="mall-specil-price-total__number">￥{{discountPrice}}</span>
          </div>
          <div class="mall-specil-price__sub">已优惠 ￥{{useCouponPrice}}</div>
        </div> -->
        <div
          v-else
          class="mall-specil-confirm__btn mall-specil-confirm__btn--big"
          :style="isBtnDisabled ? 'opacity: 0.4': ''"
          @click="handleConfirm">{{ onePurchase ? '确认支付' : '确认' }}</div>
        </slot>
    </div>
  </MallPopup>
</template>

<script>
import { MallGoods, MallPopup, MallSpecilPanel } from './index.js';
import { sub, add } from '@utils';
import { mapActions } from 'vuex';
import { countPrice, countGoodsDiscountInfo } from '@/utils/countDiscount';

export default {
  name: 'MallSpecilPopup',
  components: {
    MallPopup,
    MallGoods,
    MallSpecilPanel
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    goodsData: {
      type: [Object, Array],
      default: () => []
    },
    onePurchase: {
      type: Boolean,
      default: false
    },
    // 是否需要计算优惠价格
    needCountDiscount: {
      type: Boolean,
      default: false
    },
    showBuy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      specile: [],
      goodsList: [],
      hasValue: [],
      showActualPrice: 0,           // 售卖价格
      discountAfterPrice: 0,        // 优惠后价格
      discountLabel: '',            // 优惠标签
      discountPrice: 0,             // 优惠的价格
      goodsHasStock: [],
      title: '确认上课时间'
    };
  },
  watch: {
    goodsData(val) {
      this.init();
    },
  },
  computed: {
    allNoStock() {
      if (this.goodsHasStock.length != this.goodsList.length) {
        return false;
      }
      return this.goodsHasStock.find(item => item.hasStock) ? false : true;
    },
    isBtnDisabled() {
      let status = true;
      let count = 0;
      this.hasValue.forEach(item => {
        if (item.skuId) {
          count++;
        }
      });
      // 只有单个商品的时候
      if (!Array.isArray(this.goodsData)) {
        if (count == this.hasValue.length && count !== 0) {
          status = false;
        } else {
          status = true;
        }
      } else {
        if (count == this.goodsList.length && count !== 0) {
          status = false;
        } else {
          status = true;
        }
      }
      return status;
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('shoppingCart', ['acCartDisInOrder']),
    // 初始化数据，进行深拷贝
    init() {
      this.clear();
      if (!Array.isArray(this.goodsData)) {
        this.title = this.onePurchase ? this.goodsData.title : '确认上课时间';
        this.goodsList = JSON.parse(JSON.stringify([this.goodsData]));
      } else {
        // 过滤无规格商品
        const hasSpecil = this.goodsData.filter(item => item.upSpecilName);
        this.goodsList = JSON.parse(JSON.stringify(hasSpecil));
      }
    },

    // @aigc:start 2024/11/18-16:50
    // 清空数据
    clear() {
      this.goodsList = [];
      this.hasValue = [];
      this.goodsHasStock = [];
      this.showActualPrice = 0;
      this.discountAfterPrice = 0;
      this.discountLabel = '';
      this.discountPrice = 0;
    },
    // @aigc:end 2024/11/18-16:50

    // 计算组合商品优惠价格
    getCouponChopCartDisInOrder() {
      // 有规格的skuIds
      let skuIds = [];
      const goodsSkuIds = this.hasValue.map(item => {
        if (item.skuId) {
          skuIds.push(item.skuId);
          return { goodsSkuId: item.skuId };
        } else {
          skuIds.push(item.goodsId);
          return { goodsId: item.goodsId };
        }
      });

      let total = 0;
      // 无规格的ids
      const noSpecilGoods = this.goodsData.filter(item => !item.upSpecilName);
      const noSpecilGoodsSkuIds = noSpecilGoods.map(item => ({ goodsSkuId: item.skuId }));
      // 计算无规格商品总价
      noSpecilGoods.forEach(item => {
        total += add(total, item.specilMapping[0].actualPrice);
      });

      // 计算总价
      this.goodsList.forEach(item => {
        const r = item.specilMapping.find(it => skuIds.includes(it.skuId) || skuIds.includes(it.goodsId));
        r && (total = add(total, r.actualPrice));
      });

      this.acCartDisInOrder([...goodsSkuIds, ...noSpecilGoodsSkuIds]).then(res => {
        // if (!res.data.recdGoodsIds) {
        //   return;
        // }
        res.data.showActualPrice = total;
        const { discountPrice, discountAfterPrice } = countPrice(res.data);
        this.discountAfterPrice = discountAfterPrice;
        this.discountPrice = discountPrice;
        this.showActualPrice = total;
        this.discountLabel = res.data.discountLabel;
      }).catch(err => {
      });
    },
    // 计算单商品优惠价格
    getSingleGoodsDiscount() {
      if (!this.goodsList.length || this.goodsList.length > 1) {
        return;
      }
      const data = this.goodsList[0];
      const value = this.hasValue[0];
      const { discountPrice, discountAfterPrice, showActualPrice, discountLabel } = countGoodsDiscountInfo(data, value?.skuId);

      this.discountPrice = discountPrice;
      this.discountLabel = discountLabel;
      this.discountAfterPrice = discountAfterPrice;
      this.showActualPrice = showActualPrice;
    },

    // 接收商品库存状态 是否有规格hasSpecil
    specilLoad({ hasStock, goodsId }) {
      const index = this.goodsHasStock.findIndex(item => item.goodsId === goodsId);
      if (index > -1) {
        this.$set(this.goodsHasStock, index, { hasStock, goodsId });
      } else {
        this.goodsHasStock.push({ hasStock, goodsId });
      }
    },
    // 选中规格
    onChange(val) {
      const index = this.hasValue.findIndex(item => item.goodsId === val.goodsId);
      if (index > -1) {
        this.$set(this.hasValue, index, val);
      } else {
        this.hasValue.push(val);
      }

      if (this.hasValue.length < this.goodsList.length || !this.needCountDiscount) {
        return;
      }

      // 判断是否为全部组合商品
      const isAllGroup = this.goodsList.every(item => item.goodsType == 2);
      if (!isAllGroup) {
        // 处理单商品优惠
        this.getSingleGoodsDiscount();
      } else {
        // 处理组合商品优惠
        this.getCouponChopCartDisInOrder();
      }
    },
    // 窗口打开
    onOpen() {
      this.hasValue = [];
    },
    // 窗口关闭
    onClose() {
      this.$emit('input', false);
    },
    // 确认
    handleConfirm() {
      if (this.isBtnDisabled) {
        this.$coolToast({
          text: '请选择正确的规格!',
          time: 1000
        });
        return;
      }
      if (!Array.isArray(this.goodsData)) {
        this.goodsData.upSpecilId = this.goodsList[0].upSpecilId;
        this.goodsData.downSpecilId = this.goodsList[0].downSpecilId;
        this.goodsData.skuId = this.goodsList[0].skuId;
      } else {
        this.goodsList.forEach((item) => {
          const index = this.goodsData.findIndex(goods => goods.goodsId === item.goodsId);
          this.goodsData[index].upSpecilId = item.upSpecilId;
          this.goodsData[index].downSpecilId = item.downSpecilId;
          this.goodsData[index].skuId = item.skuId;
        });
      }

      this.$emit('onConfirm', { value: this.hasValue, goodsData: this.goodsData });

      return { value: this.hasValue, goodsData: this.goodsData };
    }
  }
};
</script>

<style lang="stylus" scoped>
.mall-specil-confirm {
  display: flex;
  align-items: center;
  min-height: 0.4rem;
  padding: 9px 20px 10px;
  .left__price {
    flex: 1;
    color: #ff5f2e;
    font-size: 15px;
    font-family: Oswald-Medium;
  }
  .right__btn {
    min-width: 140px;
    height: 0.4rem;
    padding: 0 15px;
    text-align: center;
    background: #ff5f2e;
    border-radius: 0.2rem;
    font-size: .14rem;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: #fff;
    &-label {
      margin-bottom: 3px;
    }
    &-text {
      font-size: 11px;
      &--big {
        font-size: 14px;
      }
    }
  }
}
.mall-specil-confirm__btn {
  width: 120px;
  height: 0.4rem;
  text-align: center;
  line-height: .4rem;
  background: #ff5f2e;
  border-radius: 0.2rem;
  font-size: .15rem;
  font-family: PingFangSC-Medium,PingFang SC;
  font-weight: 500;
  color: #fff;
  &.mall-specil-confirm__btn--big {
    width: 100%;
  }
}
.mall-specil-price {
  flex: 1;
  .mall-specil-price-total {
    display: flex;
    align-items: center;
  }
  .mall-specil-price-total__label {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #41414D;
  }
  .mall-specil-price-total__number {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FF5F2E;
  }
  .mall-specil-price__sub {
    height: 17px;
    padding-top: 4px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF5F2E;
    line-height: 17px;
  }

}
</style>